/* eslint-disable no-console */
/* eslint-disable max-len */
import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';
import React, { useContext, useRef, useState } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { LanguageContext } from '../../../../../../../libs/Context';
import { IoAdd } from 'react-icons/io5';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { createFeedContext } from '../../CreationPopup';
import { onDropRejected, uploadProgressImg } from '../../MediaDrivePopup/Components/Common';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';

const EditorImagePreview = (props) =>
{
	const { uploadedFiles, handleSlctImg, applyImgFilters, setUploadedFiles, initialState } = props;
	const scrollRef = useRef<HTMLDivElement | null>(null);
	const { language } = useContext(LanguageContext);
	const { createFeed } = useContext(createFeedContext);
	const [ loading, setLoading ] = useState<boolean>(false);
	const userData = useSelector((state:any) => state?.mysession?.session);

	const scrollLeft = () =>
	{
		if (scrollRef.current)
		{
			scrollRef.current.scrollBy({ left: -120, behavior: 'smooth' });
		}
	};

	const scrollRight = () =>
	{
		if (scrollRef.current)
		{
			scrollRef.current.scrollBy({ left: 120, behavior: 'smooth' });
		}
	};
	const path = `${userData?.companyId}/feed`;

	const onDrop = (acceptedFiles) =>
	{
		setLoading(true);
		const totalLength = acceptedFiles?.length + uploadedFiles?.length + (createFeed?.media)?.length;

		// if (([ ...acceptedFiles, ...uploadedFiles ]?.reduce((acc, curr) => acc + (curr?.size || 0), 0)) > 250 * 1024 * 1024)
		if (([ ...acceptedFiles, ...uploadedFiles ?? [], ...createFeed?.media ?? [] ]?.reduce((acc, curr) => acc + (curr?.size || 0), 0)) > 250 * 1024 * 1024)
		{
			toast.error(language.cannotUploadMoreThan250MB, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
			setLoading(false);

			return;
		}
		else if (totalLength > 5)
		{
			toast.error(language.cannotUploadMoreThan5Files, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
			setLoading(false);

			return;
		}
		const uploadFilesSys = async (file) =>
		{
			return await uploadProgressImg(file, setLoading, path, initialState);
		};

		const handleFiles = async () =>
		{
			try
			{
				const newArr = await Promise.all(acceptedFiles?.map(uploadFilesSys));

				setUploadedFiles([ ...uploadedFiles, ...newArr ]);
			}
			catch (err)
			{
				console.log(err);
			}
			finally
			{
				setLoading(false);
			}
		};

		handleFiles();
	};

	const acceptFiles: DropzoneOptions = {
		maxFiles : 5 - (uploadedFiles?.length + (createFeed?.media ?? [])?.length),
		accept   : { 'image/*': [ '.png', '.gif', '.jpeg', '.jpg', '.webp', '.heic' ] },

		onDrop,
		onDropRejected : (fileRejections) =>
		{
			onDropRejected(fileRejections, 'image', language);
		}
	};

	const { getRootProps, getInputProps } = useDropzone(acceptFiles);

	return (
		<Grid
			item
			xs={12}
			sx={{
				display        : 'flex',
				justifyContent : {
					xs : 'flex-start',
					sm : 'start'
				},
				alignItems : 'start',
				width      : '100vw'
			}}
		>
			{loading && <Loading/>}
			<Stack
				direction={'column'}
				sx={{
					width                     : 'var(--percent100)',
					position                  : 'relative',
					'&:hover .scroll-buttons' : { visibility: 'visible' }
				}}
			>
				<Typography fontWeight='var(--font500)' mt={1}>
					{language?.selectedImages}
				</Typography>

				{/* Left arrow button */}
				<IconButton
					onClick={scrollLeft}
					className='scroll-buttons'
					sx={{
						position        : 'absolute',
						top             : '60%',
						left            : 12,
						transform       : 'translateY(-50%)',
						zIndex          : 1,
						color           : 'var(--black)',
						backgroundColor : 'var(--whiteColor)',
						boxShadow       : 1,
						padding         : '0',
						height          : 'var(--pixel40)',
						width           : 'var(--pixel40)',
						display         : { xs: 'flex', sm: 'none' },
						alignItems      : 'center',
						justifyContent  : 'center',
						visibility      : 'hidden',
						'&:hover'       : {
							backgroundColor : '#e0f7fa'
						},
						'&:active' : {
							backgroundColor : '#e0f7fa'
						}
					}}
				>
					<Box sx={{ position: 'relative', left: '5px' }} display='flex' alignItems='center'>
						<ArrowBackIosIcon />
					</Box>
				</IconButton>

				<Box
					ref={scrollRef}
					sx={{
						display                 : 'flex',
						flexWrap                : 'nowrap',
						overflowX               : 'scroll',
						WebkitOverflowScrolling : 'touch',
						'&::-webkit-scrollbar'  : {
							display : 'none'
						}
					}}
					gap={1}
				>
					{uploadedFiles?.length > 0 && uploadedFiles?.map((image, index) => (
						<Box

							mt={1}
							key={image?.key || image?.url}
							sx={{
								position     : 'relative',
								cursor       : 'pointer',
								borderRadius : 'var(--pixel4)'
							}}
							onClick={() => handleSlctImg(image)}
						>
							<Box
								component='img'
								src={image?.existImg || image?.url}
								alt={`Image ${index + 1}`}
								sx={{
									width        : 80,
									height       : 80,
									objectFit    : 'cover',
									borderRadius : '6px'
								}}
							/>
							{applyImgFilters?.key === image?.key && (
								<IconButton
									sx={{
										position        : 'absolute',
										top             : '-5px',
										right           : '-5px',
										color           : 'var(--whiteColor)',
										backgroundColor : 'white',
										borderRadius    : 'var(--percent50)',
										boxShadow       : 2,
										padding         : '0'
									}}
								>
									<img src='/images/icons/CheckImg.svg' alt='' />
								</IconButton>
							)}
						</Box>
					))}

					{(uploadedFiles?.length + (createFeed?.media ?? [])?.length) < 5 &&
					<Box {...getRootProps()} sx={{
						width        : '80px',
						height       : '80px',
						border       : '1px solid var(--primaryColor)',
						borderRadius : 'var(--pixel4)',
						margin       : '5px',
						cursor       : 'pointer'

					}} display={'flex'} justifyContent={'center'} alignItems={'center'} mt={1}
					>
						<input
							{...getInputProps()}
							accept={'image/*'}
						/>
						<IoAdd color='var(--primaryColor)' fontSize={26}/>
					</Box>
					}
				</Box>
				<IconButton
					onClick={scrollRight}
					className='scroll-buttons'
					sx={{
						position        : 'absolute',
						top             : '60%',
						right           : 12,
						transform       : 'translateY(-50%)',
						zIndex          : 1,
						color           : 'var(--black)',
						backgroundColor : 'var(--whiteColor)',
						boxShadow       : 1,
						padding         : '0',
						height          : 'var(--pixel40)',
						width           : 'var(--pixel40)',
						display         : { xs: 'flex', sm: 'none' },
						visibility      : 'hidden', // Initially hidden
						'&:hover'       : {
							backgroundColor : '#e0f7fa'
						},
						'&:active' : {
							backgroundColor : '#e0f7fa'
						}
					}}
				>
					<ArrowForwardIosIcon />
				</IconButton>
			</Stack>
		</Grid>
	);
};

export default EditorImagePreview;
